import React, { useEffect, useState } from "react";

const WelcomeModal = () => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const hasVisited = localStorage.getItem("sevelian_first_visit");
        if (!hasVisited) {
            setIsOpen(true);
            localStorage.setItem("sevelian_first_visit", "true");
        }
    }, []);

    const closeModal = () => setIsOpen(false);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999]">
            <div className="bg-white rounded-2xl shadow-2xl w-[90%] max-w-md p-8 relative animate-fadeIn text-center">
                {/* Close Button */}
                <button
                    onClick={closeModal}
                    className="absolute top-3 right-4 text-gray-500 hover:text-black text-2xl font-bold"
                >
                    ×
                </button>

                {/* Logo or Brand Name */}
                <h2 className="text-3xl font-serif text-gray-900 mb-3 tracking-wide">
                    Welcome to <span className="text-[#1E3A8A]">Sevelian</span>
                </h2>

                {/* Tagline */}
                <p className="text-gray-600 mb-6 text-sm leading-relaxed">
                    Experience premium linen shirts crafted with precision and style —
                    embrace the timeless <span className="italic">old money</span> aesthetic.
                </p>

                {/* CTA Button */}
                <button
                    onClick={closeModal}
                    className="bg-[#1E3A8A] hover:bg-[#12245A] text-white px-8 py-2 rounded-full text-sm tracking-wide transition-all"
                >
                    Explore Collection
                </button>
            </div>
        </div>
    );
};

export default WelcomeModal;
